module.exports = __webpack_public_path__ + "static/img/Bruce.Reid.5665286.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bruce.Reid.jpg
// module id = GmRU
// module chunks = 0